import React from 'react';
import './Button.css';

/*
  Shared button (IMP-036).
  variant: "primary" (gradient), "inverse" (white on coral), "secondary" (grey-blue)
  fullWidth: stretch to the container width
  loading: show a spinner and ignore clicks while an action runs (IMP-093)
  className: page-specific layout (width, margins) only — not colours
*/
export default function Button({
    variant = "primary",
    fullWidth = false,
    loading = false,
    type = "button",
    className = "",
    children,
    ...rest
}) {
    const classes = [
        "Button",
        `Button--${variant}`,
        fullWidth ? "Button--full" : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <button type={type} className={classes} {...rest} disabled={rest.disabled || loading} aria-busy={loading || undefined}>
            {loading && <span className="Button--spinner" aria-hidden="true"></span>}
            {children}
        </button>
    );
}
